var $8613f5aa54c2ece8$exports = {};
$8613f5aa54c2ece8$exports = {
    "colorFormat": `\u{424}\u{43E}\u{440}\u{43C}\u{430}\u{442} \u{446}\u{432}\u{435}\u{442}\u{430}`,
    "hex": `Hex`,
    "hsb": `HSB`,
    "hsl": `HSL`,
    "rgb": `RGB`
};


export {$8613f5aa54c2ece8$exports as default};
//# sourceMappingURL=ru-RU.mjs.map
